// extracted by mini-css-extract-plugin
export default {"root":"AppForm_root__I+pdZ","formInput":"AppForm_formInput__DYBA5"};